/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { AppState } from '@core/app-state/reducers';
import { CategoryModel } from '@features/admin/option-management/models/category.model';
import { OptionType } from '@features/admin/option-management/models/option-type.enum';
import { OptionModel } from '@features/admin/option-management/models/option.model';
import { SubCategoryModel } from '@features/admin/option-management/models/sub-category.model';
import { optionSelector } from '@features/admin/option-management/store/option.selectors';
import { Researcher } from '@features/admin/researcher-management/models/researcher.model';
import { ResearcherService } from '@features/admin/researcher-management/services/researcher.service';
import { ProtocolModel } from '@features/protocols/models/protocol.model';
import { protocolById } from '@features/protocols/store/protocol.actions';
import { ReportService } from '@features/reports/service/report.service';
import { StatusReportDataSource } from '@features/reports/status-report.dataSource';
import { select, Store } from '@ngrx/store';
import { ApiService } from '@shared/services/api/api.service';
import { NgxNotifyService } from '@shared/services/ngx-notify/ngx-notify.service';
import { merge, Observable, of, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { displayResearcher as displayResearcherUtil,formatResearcher as formatResearcherUtil, formatPhone as formatPhoneUtil} from '@shared/researcher-format.util';

@Component({
  selector: 'app-statusreport',
  templateUrl: './statusreport.component.html',
  styleUrls: ['./statusreport.component.scss']
})
export class StatusReportComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  private destroyed$ = new Subject<void>();
  
  schools!: OptionModel[];
  filteredSchools$!: Observable<OptionModel[]>;
  institutions!: OptionModel[];
  filteredInstitutions$!: Observable<OptionModel[]>;
  collaboratingInstitutions!: OptionModel[];
  filteredCollaboratingInstitutions$!: Observable<OptionModel[]>;
  fundingAgencies!: OptionModel[];
  filteredFundingAgencies$!: Observable<OptionModel[]>;
  departments!: OptionModel[];
  filteredDepartments$!: Observable<OptionModel[]>;
  status!: OptionModel[];
  filteredStatus$!: Observable<OptionModel[]>;
  investigators!: OptionModel[];
  filteredPrincipalInvestigators$!: Observable<Researcher[]>;
  typeOfReview!: OptionModel[];
  filteredTypeOfReview$!: Observable<OptionModel[]>;
  ntrIrbCoordinators!: OptionModel[];
  filteredNtrIrbCoordinators$!: Observable<Researcher[]>;
  typeOfResearch!: OptionModel[];
  filteredTypeOfResearch$!: Observable<OptionModel[]>;
  natureOfResearch!: OptionModel[];
  filteredNatureOfResearch$!: Observable<OptionModel[]>;
  sponsoredClinicalTrials!: OptionModel[];
  filteredSponsoredClinicalTrials$!: Observable<OptionModel[]>;
  filteredIrbofRecords$!: Observable<OptionModel[]>;
  irbofRecords!: OptionModel[];
  filteredSponsorTypes$!: Observable<CategoryModel[]>;
  sponsorTypes!: OptionModel[];
  filteredSponsorNames$!: Observable<SubCategoryModel[]>;
  sponsorNames!: OptionModel[];

  dateMultiSelect: any[] = [{ value: 'approvalThrough', label: 'Approval Through Date' }, { value: 'completeDate', label: 'Complete Date' },
  { value: 'continuingReviewDate', label: 'Continuing Review Date' }, { value: 'initialApprovalDate', label: 'Initial Approval Date' },
  { value: 'initialReview', label: 'Initial Review Date' }, { value: 'mostRecentReview', label: 'Most Recent Review Date' },
  { value: 'sendNextReviewDate', label: 'Send Next Review Date' }, { value: 'submissionDate', label: 'Submission Date' }];

  downloadingFullReport = false;
  downloadingStatusReport = false;
  dataSource!: StatusReportDataSource;
  displayedColumns = ['irbNumber', 'institutionId', 'schoolId', 'departmentId', 'principalInvestigatorId', 'ntrIrb_CoordinatorId', 'protocolStatusId', 'typeOfReviewId', 'approvalThrough', 'sendNextReviewDate'];
  subs$: Subscription[] = [];
  constructor(private store: Store<AppState>,
    private fb: FormBuilder,
    public api: ApiService,
    public reportService: ReportService,
    private researcherService: ResearcherService,
    private router: Router,
    private notify: NgxNotifyService,) { }

  ngOnInit(): void {
    this.setFormOptions();
    this.dataSource = new StatusReportDataSource(this.api);
    this.loadPage();
   
  }

  displayFn(option: OptionModel): string {
    return option && option.name ? option.name : '';
  }

  checkValue(event: any) {
    if (event?.value !== null) {
      this.reportService.form.controls.dates.enable();
    } else {
      this.reportService.form.controls.dates.disable();
    }
  }

  resetFilter(): void {
    this.reportService.form.reset();
    this.reportService.pageIndex = this.paginator.pageIndex = 0;//reset index to 0 
    this.reportService.form.controls.dates.disable();
    this.setFormOptions();
    this.insert(this.reportService.form.value);
  }

  loadPage(): void {
    // tslint:disable-next-line: max-line-length
    this.paginator.pageIndex = this.reportService.pageIndex;
    this.paginator.pageSize = this.reportService.pageSize;
    this.dataSource.loadData(this.reportService.filter, this.sort.active, this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);
  }

  sortData(): void {
    this.reportService.pageIndex = this.paginator.pageIndex = 0;//reset index to 0 
    this.loadPage();
  }

  onSubmit(): void {
    this.insert(this.reportService.form.value);
  }

  downloadExcel(fullReport: boolean) {
    if (fullReport === true) {
      this.downloadingFullReport = true;
      this.reportService.filter = this.reportService.filter + `&forStatusReport=false&fullReport=true`;
    } else {
      this.downloadingStatusReport = true;
      this.reportService.filter = this.reportService.filter + `&forStatusReport=true&fullReport=false`;
    }
    this.subs$.push(
      this.api.downloadExcelFile('report?' + this.reportService.filter).subscribe(blob => {
        if (blob != null) {
          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(blob);
          a.href = objectUrl;
          if (fullReport) {
            a.download = 'FullReport';
          } else {
            a.download = 'StatusReport';
          }
          a.click();
          URL.revokeObjectURL(objectUrl);
          this.downloadingFullReport = false;
          this.downloadingStatusReport = false;
          // resetting filter back to false so that other filters still work properly
          this.reportService.filter = this.reportService.filter.replace('&forStatusReport=false&fullReport=true', '');
          this.reportService.filter = this.reportService.filter.replace('&forStatusReport=true&fullReport=false', '');
        }
      },
        (error: any) => {
          this.downloadingFullReport = false;
          this.downloadingStatusReport = false;
          this.reportService.filter = this.reportService.filter.replace('&forStatusReport=false&fullReport=true', '');
          this.reportService.filter = this.reportService.filter.replace('&forStatusReport=true&fullReport=false', '');
        })
    );
  }

  view(protocolId: number): void {
    this.store.dispatch(protocolById({ id: protocolId }));
    this.router.navigate(['/protocol', protocolId]);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this.subs$.forEach(sub => sub?.unsubscribe());
  }

  private setFormOptions(): void {
    this.subs$.push(this.store.pipe(select(optionSelector.optionsByType(OptionType.institution))).subscribe((options: OptionModel[]) => {
      this.institutions = options;
      this.filteredInstitutions$ = this.reportService.form.controls.institutionId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name, this.institutions) : this.institutions.slice()),takeUntil(this.destroyed$));
    }));

    this.subs$.push(this.store.pipe(select(optionSelector.optionsByType(OptionType.collaboratingInstitution))).subscribe((options: OptionModel[]) => {
      this.collaboratingInstitutions = options;
      this.filteredCollaboratingInstitutions$ = this.reportService.form.controls.collaboratingInstitutionId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name, this.collaboratingInstitutions) : this.collaboratingInstitutions.slice()),takeUntil(this.destroyed$));
    }));

    this.subs$.push(
      this.store.pipe(select(optionSelector.categories)).subscribe((categories: CategoryModel[]) => {
        const sponsorTypes = categories
          .filter(cat => cat.type?.toLowerCase() === 'sponsor')
          .map(cat => ({ id: cat.id, name: cat.name } as OptionModel));
    
        this.sponsorTypes = sponsorTypes; // Optional: store raw list if needed
    
        this.filteredSponsorTypes$ = this.reportService.form.controls.sponsorTypeCategoryId.valueChanges.pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value?.name),
          map(name => name ? this._filter(name, sponsorTypes) : sponsorTypes.slice()),
          takeUntil(this.destroyed$)
        );
      })
    );

    this.subs$.push(
      this.store.pipe(select(optionSelector.sponsorSubCategories)).subscribe((subCategories: SubCategoryModel[]) => {
        const sponsorNames = subCategories
          .map(cat => ({ id: cat.id, name: cat.name } as OptionModel));
        this.sponsorNames = sponsorNames; 
        this.filteredSponsorNames$ = this.reportService.form.controls.sponsorNameSubCategoryId.valueChanges.pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value?.name),
          map(name => name ? this._filter(name,  this.sponsorNames) :  this.sponsorNames.slice()),
          takeUntil(this.destroyed$)
        );
      })
    );
    
    this.subs$.push(this.store.pipe(select(optionSelector.optionsByType(OptionType.irbofRecord))).subscribe((options: OptionModel[]) => {
      this.irbofRecords = options;
      this.filteredIrbofRecords$ = this.reportService.form.controls.irbOfRecordId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name, this.irbofRecords) : this.irbofRecords.slice()),takeUntil(this.destroyed$));
    }));

    this.subs$.push(this.store.pipe(select(optionSelector.optionsByType(OptionType.fundingAgency))).subscribe((options: OptionModel[]) => {
      this.fundingAgencies = options;
      this.filteredFundingAgencies$ = this.reportService.form.controls.fundingAgencyId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name, this.fundingAgencies) : this.fundingAgencies.slice()),takeUntil(this.destroyed$));
    }));

    this.subs$.push(this.store.pipe(select(optionSelector.optionsByType(OptionType.sponsoredClinicalTrial))).subscribe((options: OptionModel[]) => {
      this.sponsoredClinicalTrials = options;
      this.filteredSponsoredClinicalTrials$ = this.reportService.form.controls.sponsoredClinicalTrialId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name, this.sponsoredClinicalTrials) : this.sponsoredClinicalTrials.slice()),takeUntil(this.destroyed$));
    }));

    this.subs$.push(this.store.pipe(select(optionSelector.optionsByType(OptionType.natureOfResearch))).subscribe((options: OptionModel[]) => {
      this.natureOfResearch = options;
      this.filteredNatureOfResearch$ = this.reportService.form.controls.natureOfResearchId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name, this.natureOfResearch) : this.natureOfResearch.slice()),takeUntil(this.destroyed$));
    }));

    this.subs$.push(this.store.pipe(select(optionSelector.optionsByType(OptionType.department))).subscribe((options: OptionModel[]) => {
      this.departments = options;
      this.filteredDepartments$ = this.reportService.form.controls.departmentId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name, this.departments) : this.departments.slice()),takeUntil(this.destroyed$));
    }));

    
      this.filteredPrincipalInvestigators$ = this.reportService.form.controls.principalInvestigatorId.valueChanges.pipe(
        startWith(''),
               debounceTime(300),
                 distinctUntilChanged(),
                 switchMap(value => {
                   if (typeof value === 'string') {
                     return this.researcherService.searchResearchers(value, 'PrincipalInvestigator');
                   }
                    return of([]);
           }));
    

   
      this.filteredNtrIrbCoordinators$ = this.reportService.form.controls.ntrIrb_CoordinatorId.valueChanges.pipe(
        startWith(''),
        debounceTime(300),
          distinctUntilChanged(),
          switchMap(value => {
            if (typeof value === 'string') {
              return this.researcherService.searchResearchers(value, 'NTRIRBCoordinator');
            }
             return of([]);
    }));

    this.subs$.push(this.store.pipe(select(optionSelector.optionsByType(OptionType.school))).subscribe((options: OptionModel[]) => {
      this.schools = options;
      this.filteredSchools$ = this.reportService.form.controls.schoolId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name, this.schools) : this.schools.slice()),takeUntil(this.destroyed$));
    }));
    this.subs$.push(this.store.pipe(select(optionSelector.optionsByType(OptionType.protocolStatus))).subscribe((options: OptionModel[]) => {
      this.status = options;
      this.filteredStatus$ = this.reportService.form.controls.statusId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name, this.status) : this.status.slice()),takeUntil(this.destroyed$));
    }));
    this.subs$.push(this.store.pipe(select(optionSelector.optionsByType(OptionType.typeOfReview))).subscribe((options: OptionModel[]) => {
      this.typeOfReview = options;
      this.filteredTypeOfReview$ = this.reportService.form.controls.typeOfReviewId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name, this.typeOfReview) : this.typeOfReview.slice()),takeUntil(this.destroyed$));
    }));
    this.subs$.push(this.store.pipe(select(optionSelector.optionsByType(OptionType.typeOfResearch))).subscribe((options: OptionModel[]) => {
      this.typeOfResearch = options;
      this.filteredTypeOfResearch$ = this.reportService.form.controls.typeOfResearchId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filter(name, this.typeOfResearch) : this.typeOfResearch.slice()),takeUntil(this.destroyed$));
    }));
  }
  private _filter(name: string, optionList: OptionModel[]): any {
    const filterValue = name.trim().toLowerCase();
    return optionList.filter(option => option.name.trim().toLowerCase().includes(filterValue));
  }

  private insert(data: any): void {
    if (data != null) {
      this.reportService.filter = '';
      if (data.schoolId != null && data.schoolId !== undefined && data.schoolId !== 0 && data.schoolId !== '') {
        if (isNaN(parseInt(data.schoolId.id))) {
          this.notify.error(`School has invalid value: ${data.schoolId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `schoolId=${data.schoolId.id}&`;
        }
      }
      if (data.institutionId != null && data.institutionId !== undefined && data.institutionId !== 0 && data.institutionId !== '') {
        if (isNaN(parseInt(data.institutionId.id))) {
          this.notify.error(`Institution has invalid value: ${data.institutionId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `institutionId=${data.institutionId.id}&`;
        }
      }
      if (data.sponsoredClinicalTrialId != null && data.sponsoredClinicalTrialId !== undefined && data.sponsoredClinicalTrialId !== 0 && data.sponsoredClinicalTrialId !== '') {
        if (isNaN(parseInt(data.sponsoredClinicalTrialId.id))) {
          this.notify.error(`Sponsored Clinical Trial (Drug/Device/Biologic) has invalid value: ${data.sponsoredClinicalTrialId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `sponsoredClinicalTrialId=${data.sponsoredClinicalTrialId.id}&`;
        }
      }
      if (data.irbOfRecordId != null && data.irbOfRecordId !== undefined && data.irbOfRecordId !== 0 && data.irbOfRecordId !== '') {
        if (isNaN(parseInt(data.irbOfRecordId.id))) {
          this.notify.error(`IRB of Record has invalid value: ${data.irbOfRecordId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `irbOfRecordId=${data.irbOfRecordId.id}&`;
        }
      }
      if (data.sponsorTypeCategoryId != null && data.sponsorTypeCategoryId !== undefined && data.sponsorTypeCategoryId !== 0 && data.sponsorTypeCategoryId !== '') {
        if (isNaN(parseInt(data.sponsorTypeCategoryId.id))) {
          this.notify.error(`Sponsor Type has invalid value: ${data.sponsorTypeCategoryId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `sponsorTypeCategoryId=${data.sponsorTypeCategoryId.id}&`;
        }
      }
      if (data.sponsorNameSubCategoryId != null && data.sponsorNameSubCategoryId !== undefined && data.sponsorNameSubCategoryId !== 0 && data.sponsorNameSubCategoryId !== '') {
        if (isNaN(parseInt(data.sponsorNameSubCategoryId.id))) {
          this.notify.error(`Sponsor Name has invalid value: ${data.sponsorNameSubCategoryId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `sponsorNameSubCategoryId=${data.sponsorNameSubCategoryId.id}&`;
        }
      }
      if (data.institutionId != null && data.institutionId !== undefined && data.institutionId !== 0 && data.institutionId !== '') {
        if (isNaN(parseInt(data.institutionId.id))) {
          this.notify.error(`Institution has invalid value: ${data.institutionId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `institutionId=${data.institutionId.id}&`;
        }
      }
      if (data.collaboratingInstitutionId != null && data.collaboratingInstitutionId !== undefined && data.collaboratingInstitutionId !== 0 && data.collaboratingInstitutionId !== '') {
        if (isNaN(parseInt(data.collaboratingInstitutionId.id))) {
          this.notify.error(`collaborating Institution has invalid value: ${data.collaboratingInstitutionId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `collaboratingInstitutionId=${data.collaboratingInstitutionId.id}&`;
        }
      }
      if (data.fundingAgencyId != null && data.fundingAgencyId !== undefined && data.fundingAgencyId !== 0 && data.fundingAgencyId !== '') {
        if (isNaN(parseInt(data.fundingAgencyId.id))) {
          this.notify.error(`Funding Agency has invalid value: ${data.fundingAgencyId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `fundingAgencyId=${data.fundingAgencyId.id}&`;
        }
      }
      if (data.natureOfResearchId != null && data.natureOfResearchId !== undefined && data.natureOfResearchId !== 0 && data.natureOfResearchId !== '') {
        if (isNaN(parseInt(data.natureOfResearchId.id))) {
          this.notify.error(`Nature Of ResearchId has invalid value: ${data.natureOfResearchId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `natureOfResearchId=${data.natureOfResearchId.id}&`;
        }
      }
      if (data.departmentId != null && data.departmentId !== undefined && data.departmentId !== 0 && data.departmentId !== '') {
        if (isNaN(parseInt(data.departmentId.id))) {
          this.notify.error(`Department has invalid value: ${data.departmentId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `departmentId=${data.departmentId.id}&`;
        }
      }
      if (data.principalInvestigatorId != null && data.principalInvestigatorId !== undefined && data.principalInvestigatorId !== 0 && data.principalInvestigatorId !== '') {
        if (isNaN(parseInt(data.principalInvestigatorId.id))) {
          this.notify.error(`Investigator has invalid value: ${data.principalInvestigatorId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `principalInvestigatorId=${data.principalInvestigatorId.id}&`;
        }
      }
      if (data.statusId != null && data.statusId !== undefined && data.statusId !== 0 && data.statusId !== '') {
        if (isNaN(parseInt(data.statusId.id))) {
          this.notify.error(`Status has invalid value: ${data.statusId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `statusId=${data.statusId.id}&`;
        }
      }
      if (data.typeOfReviewId != null && data.typeOfReviewId !== undefined && data.typeOfReviewId !== 0 && data.typeOfReviewId !== '') {
        if (isNaN(parseInt(data.typeOfReviewId.id))) {
          this.notify.error(`Type Of Review has invalid value: ${data.typeOfReviewId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `typeOfReviewId=${data.typeOfReviewId.id}&`;
        }
      }
      if (data.irbNumber != null) {
        this.reportService.filter = this.reportService.filter + `irbNumber=${data.irbNumber}&`;
      }
      if (data.sponsorProtocol != null) {
        this.reportService.filter = this.reportService.filter + `sponsorProtocol=${data.sponsorProtocol}&`;
      }
      if (data.startDate != null) {
        this.reportService.filter = this.reportService.filter + `startDate=${data.startDate.toLocaleString()}&`;
      }
      if (data.endDate != null) {
        this.reportService.filter = this.reportService.filter + `endDate=${data.endDate.toLocaleString()}&`;
      }
      if (data.ntrIrb_CoordinatorId != null && data.ntrIrb_CoordinatorId !== undefined && data.ntrIrb_CoordinatorId !== 0 && data.ntrIrb_CoordinatorId !== '') {
        if (isNaN(parseInt(data.ntrIrb_CoordinatorId.id))) {
          this.notify.error(`NTRIRB Coordinator has invalid value: ${data.ntrIrb_CoordinatorId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `ntrIrb_CoordinatorId=${data.ntrIrb_CoordinatorId.id}&`;
        }
      }
      if (data.irbNetNumber != null) {
        this.reportService.filter = this.reportService.filter + `irbNetNumber=${data.irbNetNumber}&`;
      }
      if (data.keyword != null) {
        this.reportService.filter = this.reportService.filter + `keyword=${data.keyword}&`;
      }
      if (data != null && data.dates != null) {

        if (data.dates.length > 0) {
          for (const dateVal of data.dates) {
            this.reportService.filter = this.reportService.filter + `${dateVal}=true&`;
          }
        }
      }
      if (data.typeOfResearchId != null && data.typeOfResearchId !== undefined && data.typeOfResearchId !== 0 && data.typeOfResearchId !== '') {
        if (isNaN(parseInt(data.typeOfResearchId.id))) {
          this.notify.error(`Type Of Research has invalid value: ${data.typeOfResearchId}`);
        } else {
          this.reportService.filter = this.reportService.filter + `typeOfResearchId=${data.typeOfResearchId.id}&`;
        }
      }
    }
    this.reportService.pageIndex = 0; // If the user applies filter, reset back to the first page.
    this.reportService.pageIndex = this.paginator.pageIndex;
    this.reportService.pageSize = this.paginator.pageSize;  
    this.loadPage();
  }

  onPageChange(event: any) {
    this.reportService.pageSize = event.pageSize;
    this.reportService.pageIndex = event.pageIndex;
    this.loadPage();
  }

  public displayResearcher = (r: Researcher | null) => displayResearcherUtil(r);
  public formatResearcher = (r: Researcher) => formatResearcherUtil(r);
  public formatPhone = (p: string) => formatPhoneUtil(p);
}
